<template>
    <main-layout>

        <app-header icon="factory">
            Ajout détenteur
        </app-header>

        <action-bar :back="{ name: 'liste-detenteurs' }">
        </action-bar>

        <form method="post" id="detenteur" class="wrap" @submit.prevent="sendForm">

            <h2>Informations générales</h2>

            <label>Type</label>
            <select v-model.trim="type" name="type" id="type">
                <option selected>Société</option>
                <option>Particulier</option>
                <option>Association</option>
            </select>

            <label>Raison sociale / Nom *</label>
            <input title="company" name="raison_sociale" id="raison_sociale" type="text" v-model.trim="raison_sociale"
                maxlength="255">

            <label>Code client</label>
            <input title="clientCode" name="code-client" id="code-client" type="text" v-model.trim="code_client"
                maxlength="255">

            <label v-show="this.type !== 'Particulier'">SIRET</label>
            <cleave :options="siretOpt" name="siret" id="siret" type="text" v-model.trim="siret"
                v-show="this.type !== 'Particulier'"></cleave>

            <div v-if="suggestion" class="geo-suggestion">
                <span>📍 {{ suggestion.preview }}</span>
                <button type="button" @click="applySuggestion">Utiliser</button>
                <button type="button" @click="suggestion = null">✕</button>
            </div>

            <label>Adresse *</label>
            <input title="address" name="adresse" id="adresse" type="text" v-model.trim="adresse" maxlength="255">

            <label>Complément d'adresse</label>
            <input title="moreAddress" name="completemnt_adresse" id="completemnt_adresse" type="text"
                v-model.trim="complement_adresse" maxlength="255">

            <label>Code postal *</label>
            <cleave :options="cpOpt" name="adresse_cp" id="adresse_cp" type="text" v-model.trim="code_postal"></cleave>

            <label>Ville *</label>
            <input title="city" name="adresse_ville" id="adresse_ville" type="text" v-model.trim="ville"
                maxlength="255">

            <label>Téléphone</label>
            <cleave :options="telOpt" name="telephone" id="telephone" type="text" v-model.trim="telephone"
                inputmode="tel"></cleave>

            <label>Email (adresse où seront envoyées les fiches)</label>
            <input title="email" name="email" id="email" type="text" v-model.trim="email" maxlength="255">

            <h2>Contact</h2>

            <label>Nom / Prenom</label>
            <input title="fullName" name="nom_contact" id="nom_contact" type="text" v-model.trim="nom" maxlength="255">

            <label>Téléphone portable</label>
            <cleave :options="telOpt" name="tel_contact" id="tel_contact" type="text" v-model.trim="portable"
                inputmode="tel"></cleave>

            <label>Ligne directe</label>
            <cleave :options="telOpt" name="ligne_directe_contact" id="ligne_directe_contact" type="text"
                v-model.trim="direct" inputmode="tel"></cleave>

            <input type="submit" name="new" value="AJOUTER" :disabled="saving">

        </form>

    </main-layout>
</template>

<script>
import Cleave from 'vue-cleave';
import Detenteur from '../../js/models/Detenteur';

require('cleave.js/dist/addons/cleave-phone.fr');

export default {

    data() {
        return {
            type: 'Société',
            raison_sociale: '',
            code_client: '',
            siret: '',
            ville: '',
            code_postal: '',
            adresse: '',
            complement_adresse: '',
            telephone: '',
            email: '',
            nom: '',
            portable: '',
            direct: '',
            actif: true,
            lat: null,
            lng: null,
            suggestion: null,
            saving: false,
            installations: [],
            siretOpt: {
                blocks: [3, 3, 3, 5],
                delimiter: ' ',
                numericOnly: true
            },
            cpOpt: {
                blocks: [2, 3, 20],
                delimiter: ' ',
                numericOnly: false
            },
            telOpt: {
                phone: true,
                phoneRegionCode: 'fr'
            }

        }
    },

    components: {
        Cleave
    },

    async mounted() {
        if (window.isMobile()) {
            if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
                try {
                    const result = await window.flutter_inappwebview.callHandler('requestGeolocation');
                    if (result !== false) {
                        this.lat = result.latitude;
                        this.lng = result.longitude;
                        await this.suggestAddressFromLocation(result.latitude, result.longitude);
                    }
                } catch (e) {
                    // Geolocation is optional — silent fail
                }
            }
        }
    },

    methods: {

        async suggestAddressFromLocation(lat, lng) {
            try {
                const response = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`,
                    { headers: { 'Accept-Language': 'fr' } }
                );
                const data = await response.json();
                const addr = data.address;
                if (!addr) return;

                const adresse = [addr.house_number, addr.road].filter(Boolean).join(' ');
                const cp = (addr.postcode || '').replace(/\s/g, '');
                const ville = addr.city || addr.town || addr.village || addr.municipality || '';
                const preview = [adresse, [cp, ville].filter(Boolean).join(' ')].filter(Boolean).join(', ');

                if (preview) this.suggestion = { adresse, cp, ville, preview };
            } catch (e) {
                // Reverse geocoding is optional — silent fail
            }
        },

        async applySuggestion() {
            const { adresse, cp, ville } = this.suggestion;
            this.suggestion = null;

            if (adresse) this.adresse = adresse;
            if (ville) this.ville = ville;
            if (cp) {
                this.code_postal = cp;
                await this.$nextTick();
                const cpEl = document.getElementById('adresse_cp');
                if (cpEl) {
                    cpEl.value = cp;
                    cpEl.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
        },

        sendForm() {
            if (this.saving) {
                return;
            }

            let router = this.$router;
            let newDet = Object.assign({}, this.$data);

            let errors = [];
            let txt = '';

            if (newDet.raison_sociale === "") {
                errors.push('la raison sociale / Nom')
            }
            if (newDet.adresse === "") {
                errors.push("l'adresse")
            }
            if (newDet.ville === "") {
                errors.push('la ville')
            }
            if (newDet.code_postal === "") {
                errors.push('le code postal')
            }

            txt = errors.join(', ');

            if ((newDet.siret.length !== 17 && newDet.siret.length !== 14) && newDet.siret.length !== 0) {
                txt += '<br/>SIRET invalide (14 chiffres)'
            }

            if (txt !== '') {

                swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error')

            } else {
                delete newDet.cpOpt;
                delete newDet.siretOpt;
                delete newDet.telOpt;
                delete newDet.suggestion;
                delete newDet.saving;

                this.saving = true;

                Detenteur.addDetenteurOffline(newDet).then(() => {
                    /*
                    if (navigator.onLine) {
                        Synchro.syncDetenteurs(true).then(() => {
                            router.push({name:'liste-detenteurs'});
                            swal('Détenteur ajouté', 'Le détenteur a bien été ajouté', 'success');
                        })
                    }else{
                    */
                    router.push({ name: 'liste-detenteurs' });
                    swal('Détenteur ajouté', 'Le détenteur a bien été ajouté', 'success')
                    /*}*/
                }, () => {
                    this.saving = false;
                    swal('Erreur', "Le détenteur n'a pas pu être enregistré", 'error');
                })
            }
        }
    },
}

</script>

<style>
form#detenteur h2 {
    text-transform: uppercase;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}
</style>

<style scoped>
.geo-suggestion {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 13px;
    color: #1d4ed8;
    margin-bottom: 8px;
}

.geo-suggestion span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.geo-suggestion button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    padding: 0;
    font-size: 13px;
    flex-shrink: 0;
}

.geo-suggestion button:first-of-type {
    font-weight: 600;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// NewDetenteur.vue?2728deaa